<template>
  <el-container class="favorite-page">
    <div class="header" :class="configStore.electronMode ? 'header-menu-wrap' : ''">
      {{ $t('favorite.myFavorite') }}
    </div>
    <div class="favorite-content">
      <div class="favorite-list" ref="listContainer" @scroll="onScroll">
        <div v-if="items.length > 0" class="items">
          <div v-for="item in items" :key="item.id" class="favorite-item" @click="onShowDetail(item)">
            <div class="item-header">
              <div class="item-type">
                <span v-if="item.messageType === 0" class="type-tag">{{ $t('favorite.textShort') }}</span>
                <img v-else-if="item.messageType === 1 && thumbUrl(item)" :src="thumbUrl(item)" class="thumb-image" />
                <i v-else-if="item.messageType === 2" class="el-icon-document type-icon"></i>
                <img v-else-if="item.messageType === 4 && videoCoverUrl(item)" :src="videoCoverUrl(item)" class="thumb-image" />
                <i v-else-if="item.messageType === 4" class="el-icon-video-play type-icon"></i>
                <i v-else class="el-icon-picture-outline type-icon"></i>
              </div>
              <div class="item-content">
                <div v-if="item.messageType === 0" class="text-content">{{ item.messageContent }}</div>
                <div v-else-if="item.messageType === 2" class="text-content">{{ fileName(item) }}</div>
                <div v-else-if="item.messageType === 4" class="image-tip">{{ $t('favorite.videoMsg') }}</div>
                <div v-else class="image-tip">{{ $t('favorite.imageMsg') }}</div>
              </div>
              <i class="el-icon-arrow-right arrow"></i>
            </div>
            <div class="item-time">{{ item.createdTime }}</div>
          </div>
        </div>
        <div v-else class="no-data">
          <no-data-tip></no-data-tip>
        </div>
        <div v-if="noMoreData && items.length > 0" class="no-more">{{ $t('favorite.noMore') }}</div>
      </div>
    </div>
  </el-container>
</template>

<script>
import NoDataTip from '../components/common/NoDataTip.vue';

export default {
  name: "FavoritePage",
  components: {
    NoDataTip
  },
  data() {
    return {
      items: [],
      noMoreData: false,
      loading: false
    }
  },
  methods: {
    onScroll(e) {
      const container = e.target;
      if (container.scrollTop + container.clientHeight >= container.scrollHeight - 30) {
        this.loadNextPage();
      }
    },
    onShowDetail(item) {
      this.$router.push({ path: '/home/favorite-detail', query: { id: item.id } });
    },
    loadNextPage() {
      if (this.loading || this.noMoreData) return;
      this.loading = true;
      const maxPageId = this.nextPageMaxId;
      this.$http({
        url: `/favorite/page?maxPageId=${maxPageId}`,
        method: 'GET'
      }).then((newItems) => {
        this.items.push(...newItems);
        this.noMoreData = newItems.length < 10;
      }).finally(() => {
        this.loading = false;
      });
    },
    thumbUrl(item) {
      if ((item.messageType === 1 || item.messageType === 4) && item.messageContent) {
        try {
          const data = JSON.parse(item.messageContent);
          return data.thumbUrl || data.originUrl || '';
        } catch (e) {
          return '';
        }
      }
      return '';
    },
    fileName(item) {
      if (item.messageType === 2 && item.messageContent) {
        try {
          const data = JSON.parse(item.messageContent);
          return data.name || '';
        } catch (e) {
          return '';
        }
      }
      return '';
    },
    videoCoverUrl(item) {
      if (item.messageType === 4 && item.messageContent) {
        try {
          const data = JSON.parse(item.messageContent);
          return data.coverUrl || '';
        } catch (e) {
          return '';
        }
      }
      return '';
    }
  },
  computed: {
    nextPageMaxId() {
      if (this.items.length > 0) {
        return this.items[this.items.length - 1].id;
      }
      return -1;
    }
  },
  mounted() {
    this.loadNextPage();
  }
}
</script>

<style lang="scss" scoped>
.favorite-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f5f6fa;

  .header {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 24px;
    font-size: 18px;
    font-weight: 600;
    color: var(--im-text-color-primary);
    background: white;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    flex-shrink: 0;
  }

  .favorite-content {
    flex: 1;
    overflow: hidden;
    padding: 20px;
    display: flex;
    justify-content: center;

    .favorite-list {
      width: 100%;
      max-width: 800px;
      overflow-y: auto;

      .items {
        .favorite-item {
          background: white;
          border-radius: 12px;
          padding: 16px 20px;
          margin-bottom: 12px;
          cursor: pointer;
          border: 1px solid rgba(0, 0, 0, 0.04);
          transition: all 0.2s ease;

          &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
          }

          .item-header {
            display: flex;
            align-items: center;
            gap: 16px;

            .item-type {
              width: 56px;
              height: 56px;
              background: var(--im-background-active);
              border-radius: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
              overflow: hidden;

              .type-tag {
                font-size: 18px;
                font-weight: 700;
                color: var(--im-color-primary);
              }

              .type-icon {
                font-size: 28px;
                color: var(--im-color-primary);
              }

              .thumb-image {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }

            .item-content {
              flex: 1;
              overflow: hidden;

              .text-content {
                font-size: 14px;
                color: var(--im-text-color);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                line-height: 1.4;
              }

              .image-tip {
                font-size: 14px;
                color: var(--im-text-color-light);
                line-height: 1.4;
              }
            }

            .arrow {
              font-size: 14px;
              color: var(--im-text-color-lighter);
              flex-shrink: 0;
            }
          }

          .item-time {
            margin-top: 12px;
            font-size: 12px;
            color: var(--im-text-color-light);
          }
        }
      }

      .no-data {
        display: flex;
        justify-content: center;
        padding-top: 200px;
      }

      .no-more {
        text-align: center;
        padding: 20px;
        font-size: 13px;
        color: var(--im-text-color-light);
      }
    }
  }
}
</style>
